import Vue from "vue";
import Vuex from "vuex";

import langs from "./modules/langs/langs";
import authenticatedUser from "./modules/authenticate/authenticated-user";
import common from "./modules/common/common-store";
import shipment from "./modules/shipment/shipment-store";
import invoice from "./modules/invoice/invoice-store";
import regInvoice from "./modules/regInvoice/reg-invoice-store";
import searchReIssue from "./modules/searchReIssue/search-re-issue-store";
import editIssueInvoice from "./modules/editIssue/invoice/edit-issue-invoice-store";
import editIssueShipment from "./modules/editIssue/shipment/edit-issue-shipment-store";
import searchIssueHistory from "./modules/searchIssueHistory/search-issue-history-store";
import searchIssueSaved from "./modules/searchIssueSaved/search-issue-saved-store";
import editIssueHistory from "./modules/editIssueHistory/edit-issue-history-store";
import transportServices from "./modules/transportServices/recommend-store";
import prohibition from "./modules/prohibition/prohibition-store";
import ImportIssueData from "./modules/ImportIssueData/import-issue-data-store";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    langs,
    authenticatedUser,
    common,
    shipment,
    invoice,
    regInvoice,
    searchReIssue,
    editIssueInvoice,
    editIssueShipment,
    searchIssueHistory,
    searchIssueSaved,
    editIssueHistory,
    transportServices,
    prohibition,
    ImportIssueData
  }
});
